module.exports = __webpack_public_path__ + "img/advantage.9bc42715.png";